import { useEffect, useState } from 'react';
import { getRequest } from '../../../../shared/components/functions';
import YearMonthMatrix from './YearMonthMatrix';
import MarginDrilldownModal from './MarginDrilldownModal';
import { businessUnitParam } from './BusinessUnitFilter';
import { toNumber } from './analyticsHelpers';

// Gross margin heatmap: net revenue minus net costs per period, built client-side
// from the same data as the revenue and costs heatmaps.
export default function MarginHeatmapCard({ businessUnitId = null, titleSuffix = '' }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [drillPeriod, setDrillPeriod] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function fetchData() {
      setLoading(true);
      const suffix = businessUnitParam(businessUnitId, true);
      const [revenue, costs] = await Promise.all([getRequest(`/api/metrics/revenue-table${suffix}`), getRequest(`/api/metrics/costs-table${suffix}`)]);
      if (cancelled) return;
      const byPeriod = {};
      (Array.isArray(revenue) ? revenue : []).forEach((row) => {
        const key = `${row.year}-${row.month}`;
        byPeriod[key] = byPeriod[key] || { year: row.year, month: row.month, margin: 0 };
        byPeriod[key].margin += toNumber(row.total_excl) - toNumber(row.credited_excl);
      });
      (Array.isArray(costs) ? costs : []).forEach((row) => {
        const key = `${row.year}-${row.month}`;
        byPeriod[key] = byPeriod[key] || { year: row.year, month: row.month, margin: 0 };
        byPeriod[key].margin -= toNumber(row.total_excl) - toNumber(row.credited_excl);
      });
      setRows(Object.values(byPeriod));
      setLoading(false);
    }
    fetchData();
    return () => {
      cancelled = true;
    };
  }, [businessUnitId]);

  return (
    <>
      <YearMonthMatrix
        title={`Gross margin heatmap${titleSuffix}`}
        subtitle="Net revenue (excl. VAT) minus net costs (excl. VAT est.) per period — green is profit, red is a period where booked costs exceeded invoiced revenue. Costs follow the booked date and big machine purchases land in one month, so single red months are normal; use the quarter or cumulative view for the honest picture."
        rows={rows}
        valueKey="margin"
        colorRgb="46, 125, 50"
        negativeColorRgb="178, 34, 34"
        loading={loading}
        onPeriodClick={setDrillPeriod}
      />
      <MarginDrilldownModal period={drillPeriod} onClose={() => setDrillPeriod(null)} businessUnitId={businessUnitId} />
    </>
  );
}
